import { useQuery } from 'react-query';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { loan_request } from '@axo/shared/data-access/types';
import { lender_filter_api } from '@axo/shared/data-access/api';
import { useContext } from 'react';
import {
  lenderFilterKeys,
  parseLenderFilterKey,
} from '../../cache-keys/lenderFilterKeys.ts';
import { queryFunction } from '../../query-function.ts';

export function useLenderFilterCheck({
  loanRequest,
  lenderIDs,
}: {
  loanRequest?: Omit<loan_request.CreateLoanRequest, 'LenderID'>;
  lenderIDs?: string[];
}) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = lenderFilterKeys.root({
    loanRequest,
    lenderIDs,
  });

  return useQuery(
    cacheKey,
    queryFunction(lender_filter_api.check(api), ({ queryKey }) =>
      parseLenderFilterKey(queryKey),
    ),
    {
      enabled:
        state.user.token.length > 0 ||
        !loanRequest ||
        !lenderIDs ||
        lenderIDs?.length === 0,
    },
  );
}
